import React from 'react';
const PerformanceReport = React.lazy(() => import('pages/PerformanceReport/PerformanceReport'));
const PerformanceReportRoutes = [
  {
    path: '/performance-report',
    exact: true,
    name: 'Báo cáo năng suất làm việc nhân viên',
    function: 'RP_PERFORMANCE',
    component: PerformanceReport,
  },
];

export default PerformanceReportRoutes;
